// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Container Component */
:host {
  display: block;
  contain: none;
  height: 100dvh;
  width: 100vw;
}

:host([hidden]) {
  display: none;
}

:host(:not([hidden])) {
  display: block;
}

:host([animated][hidden]) {
  animation: fadeOut var(--ids-motion-duration) var(--ids-motion-ease) forwards;
}

:host([animated]:not([hidden])) {
  display: block;
  animation: fadeIn var(--ids-motion-duration) var(--ids-motion-ease) forwards;
}

:host([container-queries]) {
  container-type: inline-size;
}

.ids-container {
  background-color: var(--ids-color-background-default);
  box-sizing: border-box;
  color: var(--ids-color-text-default);
  height: 100%;
  line-height: normal;
  outline: none;
  overflow: auto;
  padding: var(--ids-space-none);
  scroll-behavior: smooth;
  transition: background-color var(--ids-motion-duration) var(--ids-motion-ease), color var(--ids-motion-duration) var(--ids-motion-ease);
  width: 100%;
}
.ids-container.color-variant-alternate {
  background-color: var(--ids-color-text-default);
  color: var(--ids-color-text-inverse);
}
.ids-container[scrollable=false] {
  overflow: hidden;
}

@media (min-width: 927px) {
  :host(.app-menu)::part(container) {
    margin-bottom: var(--ids-space-none);
    transition: background-color var(--ids-motion-duration) var(--ids-motion-ease), color var(--ids-motion-duration) var(--ids-motion-ease);
    transition: width var(--ids-motion-duration) var(--ids-motion-ease), margin var(--ids-motion-duration) var(--ids-motion-ease);
  }
}

@media (min-width: 927px) {
  :host(.app-menu-is-open)::part(container) {
    margin-inline-start: 300px;
    width: calc(100% - 300px);
    transition: width var(--ids-motion-duration) var(--ids-motion-ease), margin var(--ids-motion-duration) var(--ids-motion-ease);
  }
}

@keyframes fadeIn {
  0% {
    display: none;
    opacity: 0;
  }
  1% {
    display: block;
  }
  100% {
    display: block;
    opacity: 1;
  }
}
@keyframes fadeOut {
  0% {
    display: block;
    opacity: 1;
  }
  99% {
    display: block;
  }
  100% {
    display: none;
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ids-container/ids-container.scss"],"names":[],"mappings":"AAAA,4BAAA;AAKA;EACE,cAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;AAHF;;AAMA;EACE,aAAA;AAHF;;AAMA;EACE,cAAA;AAHF;;AAMA;EACE,6EAAA;AAHF;;AAMA;EACE,cAAA;EACA,4EAAA;AAHF;;AAMA;EACE,2BAAA;AAHF;;AAMA;EACE,qDAAA;EACA,sBAAA;EACA,oCAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,8BAAA;EACA,uBAAA;EACA,uIAAA;EACA,WAAA;AAHF;AAKE;EACE,+CAAA;EACA,oCAAA;AAHJ;AAME;EACE,gBAAA;AAJJ;;AAUE;EADF;IAEI,oCAAA;IACA,uIAAA;IACA,6HAAA;EANF;AACF;;AAUE;EADF;IAEI,0BAAA;IACA,yBAAA;IACA,6HAAA;EANF;AACF;;AAUA;EACE;IACE,aAAA;IACA,UAAA;EAPF;EAUA;IACE,cAAA;EARF;EAWA;IACE,cAAA;IACA,UAAA;EATF;AACF;AAYA;EACE;IACE,cAAA;IACA,UAAA;EAVF;EAaA;IACE,cAAA;EAXF;EAcA;IACE,aAAA;IACA,UAAA;EAZF;AACF","sourcesContent":["/* Ids Container Component */\n@use '../../themes/mixins/ids-core-mixins' as mixins;\n\n// Host styles are needed here for \"placed\" components like Popup.\n// (acts as a CSS \"reset\" without needing a real one)\n:host {\n  display: block;\n  contain: none;\n  height: 100dvh;\n  width: 100vw;\n}\n\n:host([hidden]) {\n  display: none;\n}\n\n:host(:not([hidden])) {\n  display: block;\n}\n\n:host([animated][hidden]) {\n  animation: fadeOut var(--ids-motion-duration) var(--ids-motion-ease) forwards;\n}\n\n:host([animated]:not([hidden])) {\n  display: block;\n  animation: fadeIn var(--ids-motion-duration) var(--ids-motion-ease) forwards;\n}\n\n:host([container-queries]) {\n  container-type: inline-size;\n}\n\n.ids-container {\n  background-color: var(--ids-color-background-default);\n  box-sizing: border-box;\n  color: var(--ids-color-text-default);\n  height: 100%;\n  line-height: normal;\n  outline: none;\n  overflow: auto;\n  padding: var(--ids-space-none);\n  scroll-behavior: smooth;\n  transition: background-color var(--ids-motion-duration) var(--ids-motion-ease), color var(--ids-motion-duration) var(--ids-motion-ease);\n  width: 100%;\n\n  &.color-variant-alternate {\n    background-color: var(--ids-color-text-default);\n    color: var(--ids-color-text-inverse);\n  }\n\n  &[scrollable='false'] {\n    overflow: hidden;\n  }\n}\n\n// ids-app-menu pushes the container\n:host(.app-menu)::part(container) {\n  @media (min-width: mixins.$breakpoint-md) {\n    margin-bottom: var(--ids-space-none);\n    transition: background-color var(--ids-motion-duration) var(--ids-motion-ease), color var(--ids-motion-duration) var(--ids-motion-ease);\n    transition: width var(--ids-motion-duration) var(--ids-motion-ease), margin var(--ids-motion-duration) var(--ids-motion-ease);\n  }\n}\n\n:host(.app-menu-is-open)::part(container) {\n  @media (min-width: mixins.$breakpoint-md) {\n    margin-inline-start: 300px;\n    width: calc(100% - 300px);\n    transition: width var(--ids-motion-duration) var(--ids-motion-ease), margin var(--ids-motion-duration) var(--ids-motion-ease);\n  }\n}\n\n// Animation\n@keyframes fadeIn {\n  0% {\n    display: none;\n    opacity: 0;\n  }\n\n  1% {\n    display: block;\n  }\n\n  100% {\n    display: block;\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOut {\n  0% {\n    display: block;\n    opacity: 1;\n  }\n\n  99% {\n    display: block;\n  }\n\n  100% {\n    display: none;\n    opacity: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
